import bellPeppersFilledWithFetaCheese from '../assets/images/antipasto/Bell-Peppers-filled-with-feta-cheese.png'
import basilFeta from '../assets/images/antipasto/Basil-&-Fetta.png'
import greenOlives from '../assets/images/antipasto/Green-Olives-Stuffed-With-Fetta-Cheese.png'
import semiDriedTomatoes from '../assets/images/antipasto/Semi-dried-tomatoes.png'
import greekSaladMix from '../assets/images/antipasto/greek-salad-mix.png'
import persianFettaClassic from '../assets/images/antipasto/Persian-Style-Fetta-Classic.png'
import greenOlivesLemonGarlic from '../assets/images/antipasto/Green-Olives-with-Lemon-&-Garlic.png'
import mixedPittedMarinatedOlives from '../assets/images/antipasto/Mixed-Pitted-Marinated-Olives.png'
import sacilianOlives from '../assets/images/antipasto/Sicilian-Olives.png'
import sunDriedKalamataOlives from '../assets/images/antipasto/Sun-Dried-Kalamata-Olives-Unpitted-Marinated.png'

let antipasto = [
  {name: "Bell Peppers", subtitle: "Filled with Feta Cheese", image: bellPeppersFilledWithFetaCheese},
  {name: "Basil & Feta", image: basilFeta},
  {name: "Greek Salad Mix", image: greekSaladMix},
  {name: "Semi Dried Tomatoes", image: semiDriedTomatoes,
    ingredients: "Semi Dried Tomatoes (60%), Canola Oil, Mixed Herbs, Garlic & Salt."
  },
  {name: "Mixed Pitted Marinated Olives", image: mixedPittedMarinatedOlives,
    ingredients: "Kalamata Olives Pitted (24%), Green Olives Pitted (18%), Pimento Olives (18%), Mixed Herbs, Garlic & Canola Oil."
  },
  {name: "Sicilian Olives", image: sacilianOlives,
    ingredients: "Sicilian Olives (60%), Brine & Canola Oil."
  },
  {name: "Sun Dried Kalamata Olives", subtitle: 'Unpitted Marinated', image: sunDriedKalamataOlives,
    ingredients: "Sun Dried Kalamata Olives (60%), Mixed Herbs, Garlic & Canola Oil."
  },
  {name: "Sundried Tomatoes"},
  {name: "Sundried Tomato Strips"},
  {name: "Char Grilled Eggplant"},
  {name: "Char Grilled Zucchini"},
  {name: "Char Grilled Sweet Potato"},
  {name: "Char Grilled Pumpkin"},
  {name: "Char Grilled Artichoke Hearts"},
  {name: "Marinated Mushrooms"},
  {name: "Roasted Red Capsicums"},
  {name: "Sliced Red Capsicums"},
  {name: "Marinated Kalamata Olives"},
  {name: "Pitted Kalamata Olives", sizes: ["2kg", "5kg"]},
  {name: "Cracked Green Olives Pitted"},
  {name: "Green Queen Olives", subtitle: 'Filled with either Semi Dried Tomatoes, Basil, Feta, Parmesan or Anchovies', image: greenOlives},
  {name: "Green Olives", subtitle: 'With Lemon and Garlic', image: greenOlivesLemonGarlic,
    ingredients: "Green Olives Unpitted (60%), Fresh Lemon, Garlic & Canola Oil."
  },
  {name: "Papperdews Stuffed with Feta"},
  {name: "Persian Style Feta", image: persianFettaClassic,
    ingredients: "Danish Fetta (60%), Mixed Herbs, Chilli, Thyme, Cloves, Pepper & Canola Oil."
  },
  {name: "Bocconchini with Basil & Chilli"},
  {name: "Bocconchini with Semi Dried Toms"},
  {name: "Diced Feta with Lemon & Herb"},
  {name: "Diced Feta with Basil & Chilli"},
  {name: "Diced Feta & Semi Dried Tomatoes"},
  {name: "Danish Feta in Brine", sizes: ["1kg", "5kg", "10kg"]}
]

export default antipasto
